import { Injectable, Inject } from '@angular/core';

 export class ErrorDO {

	public componentName:any;
    public errorMsg :any;
    public fieldName :any;
    public fieldNameDescription: any;
    public validationLevel:any
    public validationEvent:any
    public validationType:any

    public set $componentName(value: any) {
    this.componentName = value;
  }

  public get $componentName(): any {
    return this.componentName;
  }

  public set $errorMsg(value: any) {
    this.errorMsg = value;
  }

  public get $errorMsg(): any {
    return this.errorMsg;
  }


  public set $fieldName(value: any) {
    this.fieldName = value;
  }

  public get $fieldName(): any {
    return this.fieldName;
  }


}
